/**
 * Rule actions travel as a JSON string in two spellings: the seeder persists system rules
 * as [{ "Type", "Parameters" }] (RuleActionDto's C# names) and the rule editor writes
 * [{ "type", "parameters" }]. The backend deserializes both case-insensitively; the editor
 * does not. This is the one place that maps the seeded shape onto the editor's.
 */
export interface EditorRuleAction {
  type: string;
  parameters: Record<string, unknown>;
}

export function normalizeActionsForEditor(actionsJson: string): string {
  let parsed: unknown;
  try {
    parsed = JSON.parse(actionsJson);
  } catch {
    return actionsJson;
  }
  if (!Array.isArray(parsed)) {
    return actionsJson;
  }

  const actions: EditorRuleAction[] = parsed
    .filter((a): a is Record<string, unknown> => typeof a === 'object' && a !== null)
    .map((a) => ({
      type: String(a.type ?? a.Type ?? ''),
      parameters: asRecord(a.parameters ?? a.Parameters),
    }));

  return JSON.stringify(actions);
}

function asRecord(value: unknown): Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {};
}
